import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useUiStore = create((set) => ({
  headerHeight: 0,
  sidebarWidth: 0,
  secondarySidebarLinks: [],
  filtersState: {},

  // Modals and notifications
  isDialogModalVisible: false,
  dialogModalData: {
    title: '',
    text: '',
    onConfirm: () => {},
    onCancel: () => {},
  },
  notify: () => {},
  notifyApiError: () => {},
  notifySuccess: () => {},

  setHeaderHeight: (height) => set({ headerHeight: height }),
  setSidebarWidth: (width) => set({ sidebarWidth: width }),
  setSecondarySidebarLinks: (links) => set({ secondarySidebarLinks: links }),

  // Modals and notifications
  showDialogModal: ({
    title = '',
    text = '',
    onConfirm = () => {},
    onCancel = () => {},
  }) =>
    set({
      isDialogModalVisible: true,
      dialogModalData: {
        title,
        text,
        onConfirm,
        onCancel,
      },
    }),
  setNotify: (notify) => set({ notify }),
  setNotifyApiError: (notifyApiError) => set({ notifyApiError }),
  setNotifySuccess: (notifySuccess) => set({ notifySuccess }),

  hideDialogModal: () =>
    set({
      isDialogModalVisible: false,
      dialogModalData: {
        title: '',
        text: '',
        onConfirm: () => {},
        onCancel: () => {},
      },
    }),
}));

export const useTableFiltersStore = create(
  persist(
    (set) => ({
      filtersStates: {},

      setFiltersStates: (key, filtersState) =>
        set((state) => ({
          filtersStates: {
            ...state.filtersStates,
            [key]: filtersState,
          },
        })),
    }),
    {
      name: 'tableFiltersStorage',
      storage: createJSONStorage(() => localStorage),
      // partialize: (state) => ({
      //   filtersStates: state.filtersStates,
      // }),
    }
  )
);
